import { defineMessages } from 'react-intl';

export default defineMessages({
    PolicyNumberLabel: {
        id: 'components.common.policySummaryInfo.PolicyNumberLabel',
        defaultMessage: 'Policy number:'
    },
    CoverTypeLabel: {
        id: 'components.common.policySummaryInfo.CoverTypeLabel',
        defaultMessage: 'Cover type:'
    },
    CoverLevelLabel: {
        id: 'components.common.policySummaryInfo.CoverLevelLabel',
        defaultMessage: 'Cover level:'
    },
    PlanTypeLabel: {
        id: 'components.common.policySummaryInfo.PlanTypeLabel',
        defaultMessage: 'Plan type:'
    },
    PolicyYearLabel: {
        id: 'components.common.policySummaryInfo.PolicyYearLabel',
        defaultMessage: 'Policy year:'
    },
    PolicyYearInfo: {
        id: 'components.common.policySummaryInfo.PolicyYearInfo',
        defaultMessage: '{startDate} - {endDate}'
    },
    PaymentMethodLabel: {
        id: 'components.common.policySummaryInfo.PaymentMethodLabel',
        defaultMessage: 'Payment method:'
    },
    Annual: {
        id: 'components.common.policySummaryInfo.Annual',
        defaultMessage: 'Annual'
    },
    DirectDebit: {
        id: 'components.common.policySummaryInfo.DirectDebit',
        defaultMessage: 'Direct Debit'
    },
    AmountPaidLabel: {
        id: 'components.common.policySummaryInfo.AmountPaidLabel',
        defaultMessage: 'Amount paid: '
    },
    PaidTodayLabel: {
        id: 'components.common.policySummaryInfo.PaidTodayLabel',
        defaultMessage: 'Paid today: '
    },
    MonthlyPaymentLabel: {
        id: 'components.common.policySummaryInfo.MonthlyPaymentLabel',
        defaultMessage: 'Monthly payment: '
    },
    TotalCostLabel: {
        id: 'components.common.policySummaryInfo.TotalCostLabel',
        defaultMessage: 'Total cost: '
    },
    NextInstallmentLabel: {
        id: 'components.common.policySummaryInfo.NextInstallmentLabel',
        defaultMessage: 'Next installment: '
    },
    RemainingInstallmentsLabel: {
        id: 'components.common.policySummaryInfo.RemainingInstallmentsLabel',
        defaultMessage: 'Remaining installments: '
    }
});
